module.exports = __webpack_public_path__ + "static/media/Empanelment-five.f669bbb5.png";